(function () {
    const resultsError = "Error :(";

    const searchForm = document.querySelector(".search-form-js");
    if (!searchForm) {
        return;
    }

    const searchResultsBody = document.querySelector(".search-listing__results");

    const clearAllButton = document.querySelector(".search-listing__clear-all");

    const searchInput = document.querySelector(".search-listing__input");

    const industryDropdown = document.querySelector(".industry-dropdown-menu");
    const industryCheckboxes = industryDropdown ? industryDropdown.querySelectorAll(".search-listing__checkbox") : [];

    const industryDropdownValue = document.querySelector(".search-listing__dropdown-button-select-industry");

    const solutionDropdown = document.querySelector(".solution-dropdown-menu");
    const solutionCheckboxes = solutionDropdown ? solutionDropdown.querySelectorAll(".search-listing__checkbox") : [];

    const solutionDropdownValue = document.querySelector(".search-listing__dropdown-button-select-solution");

    const benefitDropdown = document.querySelector(".benefit-dropdown-menu");
    const benefitCheckboxes = benefitDropdown ? benefitDropdown.querySelectorAll(".search-listing__checkbox") : [];

    const benefitDropdownValue = document.querySelector(".search-listing__dropdown-button-select-benefit");

    const topicDropdown = document.querySelector(".topic-dropdown-menu");
    const topicCheckboxes = topicDropdown ? topicDropdown.querySelectorAll(".search-listing__checkbox") : [];

    const topicDropdownValue = document.querySelector(".search-listing__dropdown-button-select-topic");

    const typeDropdown = document.querySelector(".type-dropdown-menu");
    const typeCheckboxes = typeDropdown ? typeDropdown.querySelectorAll(".search-listing__checkbox") : [];

    const typeDropdownValue = document.querySelector(".search-listing__dropdown-button-select-type");

    const getCheckedIndustry = () => {
        let checked = [];
        industryCheckboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                checked.push(checkbox);
            }
        });
        return checked;
    };

    const getCheckedSolution = () => {
        let checked = [];
        solutionCheckboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                checked.push(checkbox);
            }
        });
        return checked;
    };

    const getCheckedBenefit = () => {
        let checked = [];
        benefitCheckboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                checked.push(checkbox);
            }
        });
        return checked;
    };

    const getCheckedTopic = () => {
        let checked = [];
        topicCheckboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                checked.push(checkbox);
            }
        });
        return checked;
    };

    const getCheckedType = () => {
        let checked = [];
        typeCheckboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                checked.push(checkbox);
            }
        });
        return checked;
    };

    if (searchInput) {
        searchInput.addEventListener("keypress", (e) => {
            if (e.which === 13) {
                const submitButton = document.querySelector(".search-listing__submit-btn");
                submitButton ? submitButton.click() : "";
            }
        });
    }

    industryCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("click", (e) => {
            let checked = getCheckedIndustry();

            if (checkbox.length !== 0) {
                industryDropdownValue.innerText = `${checked.length} Selected`;
            } else {
                industryDropdownValue.innerText = "Select Industry";
            }
        });
    });

    solutionCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("click", () => {
            let checked = getCheckedSolution();

            if (checkbox.length !== 0) {
                solutionDropdownValue.innerText = `${checked.length} Selected`;
            } else {
                solutionDropdownValue.innerText = "Select Solution";
            }
        });
    });

    benefitCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("click", () => {
            let checked = getCheckedBenefit();

            if (checkbox.length !== 0) {
                benefitDropdownValue.innerText = `${checked.length} Selected`;
            } else {
                benefitDropdownValue.innerText = "Select Benefit";
            }
        });
    });

    topicCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("click", () => {
            let checked = getCheckedTopic();

            if (checkbox.length !== 0) {
                topicDropdownValue.innerText = `${checked.length} Selected`;
            } else {
                topicDropdownValue.innerText = "Select Topic";
            }
        });
    });

    typeCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("click", () => {
            let checked = getCheckedType();

            if (checkbox.length !== 0) {
                typeDropdownValue.innerText = `${checked.length} Selected`;
            } else {
                typeDropdownValue.innerText = "Select Type";
            }
        });
    });

    const errorHandling = () => {
        if (searchResultsBody) {
            searchResultsBody.classList.remove("loading");
            searchResultsBody.innerHTML = resultsError;
        }
    };

    const clearAllHandling = () => {
        searchForm.reset();
        industryDropdownValue ? (industryDropdownValue.innerText = "Select Industry") : "";
        solutionDropdownValue ? (solutionDropdownValue.innerText = "Select Solution") : "";
        benefitDropdownValue ? (benefitDropdownValue.innerText = "Select Benefit") : "";
        topicDropdownValue ? (topicDropdownValue.innerText = "Select Topic") : "";
        typeDropdownValue ? (typeDropdownValue.innerText = "Select Type") : "";
    };

    const fetchRequest = async (url, current, parent) => {
        const queryStringArray = url.split("?");
        const queryString = queryStringArray.length > 0 ? queryStringArray[1] : "";
        window.history.pushState("Search", "Search | CoreLogic Australia", window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + queryString);
        let response = await fetch(url);
        if (!response.ok) {
            searchResultsBody.classList.remove("loading");
            errorHandling();
        }
        searchResultsBody.classList.remove("loading");
        let html = await response.text();

        searchResultsBody.innerHTML = html;

        searchResultsBody.scrollIntoView({ behavior: "smooth" });
        getPaginationClicks();
    };

    const searchRequest = (url, current, parent) => {
        searchResultsBody.classList.add("loading");
        fetchRequest(url, current, parent);
    };

    const submitHandler = (e) => {
        e.preventDefault();
        const data = new FormData(searchForm);
        const queryString = new URLSearchParams(data).toString();
        const submitUrl = `${searchForm.dataset.action}?${queryString}`;
        const focus = e.target.closest(".search-request")?.id;
        const currentId = e.target.id;
        searchRequest(submitUrl, currentId, focus);
    };

    const clickHandler = (e) => {
        if (e.target.classList.contains("search-listing__page-btn")) {
            e.preventDefault();
            let pageUrl = searchForm.dataset.action + e.target.getAttribute("href");
            searchRequest(pageUrl, "search-listing__results");
        }
    };

    const getTabClicks = () => {
        const tabs = document.querySelectorAll(".search-listing__menu-item");
        const submitButton = document.querySelector(".search-listing__submit-btn");
        tabs.forEach((element) => {
            element.addEventListener("click", (e) => {
                e.preventDefault();
                document.querySelectorAll(".search-listing__menu-item").forEach((el) => {
                    el.classList.remove("active");
                    const inputItem = el.previousSibling.previousSibling;
                    inputItem.setAttribute("disabled", "disabled");
                });
                e.currentTarget.classList.add("active");
                const inputItem = e.currentTarget.previousSibling.previousSibling;
                inputItem.removeAttribute("disabled");
                const startRank = document.querySelector(".start_rank");
                if (startRank) {
                    startRank.value = "1";
                }
                submitButton ? submitButton.click() : "";
            });
        });
    };
    getTabClicks();

    const getPaginationClicks = () => {
        const paginations = document.querySelectorAll(".search-listing__page-btn");
        const submitButton = document.querySelector(".search-listing__submit-btn");
        paginations.forEach((element) => {
            element.addEventListener("click", (e) => {
                e.preventDefault();
                const startRank = document.querySelector(".start_rank");
                const params = new URLSearchParams(e.currentTarget.href);
                if (startRank) {
                    startRank.value = params.get("start_rank");
                    submitButton ? submitButton.click() : "";
                }
            });
        });
    };
    getPaginationClicks();
    searchForm.addEventListener("submit", submitHandler);
    searchForm.addEventListener("click", clickHandler);
    clearAllButton.addEventListener("click", clearAllHandling);

    const enableFiltersPreselect = () => {
        const queryString = new URLSearchParams(window.location.search);

        for (const [key, value] of queryString.entries()) {
            switch (key) {
                case "f.Topic|topic":
                    if (topicCheckboxes) {
                        topicCheckboxes.forEach((checkbox) => {
                            if (checkbox.value === value) {
                                checkbox.checked = true;
                            }
                            const checked = getCheckedTopic();
                            if (checkbox.length !== 0) {
                                topicDropdownValue.innerText = `${checked.length} Selected`;
                            } else {
                                topicDropdownValue.innerText = "Select Topic";
                            }
                        });
                    }
                    break;
                case "f.Benefit|benefit":
                    if (benefitCheckboxes) {
                        benefitCheckboxes.forEach((checkbox) => {
                            if (checkbox.value === value) {
                                checkbox.checked = true;
                            }
                            const checked = getCheckedBenefit();
                            if (checkbox.length !== 0) {
                                benefitDropdownValue.innerText = `${checked.length} Selected`;
                            } else {
                                benefitDropdownValue.innerText = "Select Benefit";
                            }
                        });
                    }
                    break;
                case "f.Solution|solution":
                    if (solutionCheckboxes) {
                        solutionCheckboxes.forEach((checkbox) => {
                            if (checkbox.value === value) {
                                checkbox.checked = true;
                            }
                            const checked = getCheckedSolution();
                            if (checkbox.length !== 0) {
                                solutionDropdownValue.innerText = `${checked.length} Selected`;
                            } else {
                                solutionDropdownValue.innerText = "Select Solution";
                            }
                        });
                    }
                    break;
                case "f.Industry|industry":
                    if (industryCheckboxes) {
                        industryCheckboxes.forEach((checkbox) => {
                            if (checkbox.value === value) {
                                checkbox.checked = true;
                            }
                            const checked = getCheckedIndustry();
                            if (checkbox.length !== 0) {
                                industryDropdownValue.innerText = `${checked.length} Selected`;
                            } else {
                                industryDropdownValue.innerText = "Select Industry";
                            }
                        });
                    }
                    break;
                case "f.Type|type":
                    if (typeCheckboxes) {
                        typeCheckboxes.forEach((checkbox) => {
                            if (checkbox.value === value) {
                                checkbox.checked = true;
                            }
                            const checked = getCheckedType();
                            if (checkbox.length !== 0) {
                                typeDropdownValue.innerText = `${checked.length} Selected`;
                            } else {
                                typeDropdownValue.innerText = "Select Type";
                            }
                        });
                    }
                    break;
                case "f.Tabs|all":
                case "f.Tabs|articles":
                case "f.Tabs|reports":
                case "f.Tabs|webinars":
                case "f.Tabs|podcasts":
                    const tabs = document.querySelectorAll(".search-listing__menu-item");
                    tabs.forEach((e) => {
                        document.querySelectorAll(".search-listing__menu-item").forEach((el) => {
                            el.classList.remove("active");
                            const inputItem = el.previousSibling.previousSibling;
                            inputItem.setAttribute("disabled", "disabled");
                        });
                        if (e.innerText === value) {
                            e.classList.add("active");
                            const inputItem = e.currentTarget.previousSibling.previousSibling;
                            inputItem.removeAttribute("disabled");
                        }
                    });
                    break;
            }
        }
    };

    enableFiltersPreselect();

})();
